export default __webpack_public_path__ + "static/media/tides-chapters-bg.116c6191.jpg";